import { render, staticRenderFns } from "./note-column.vue?vue&type=template&id=638ed84a"
import script from "./note-column.vue?vue&type=script&lang=js"
export * from "./note-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('638ed84a')) {
      api.createRecord('638ed84a', component.options)
    } else {
      api.reload('638ed84a', component.options)
    }
    module.hot.accept("./note-column.vue?vue&type=template&id=638ed84a", function () {
      api.rerender('638ed84a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/contact/note-column.vue"
export default component.exports